import { useEffect, useState } from "react";

import {
  subscribeAdminHolidayRequests,
  subscribeManagerHolidayRequests,
  subscribeMyHolidayRequests,
} from "../services/staffHolidayFirebase";

export const useStaffHolidayRequests = ({
  currentUserEmail,
  mode = "mine",
}) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(Boolean(currentUserEmail));
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!currentUserEmail && mode !== "admin") {
      setRequests([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    // console.log("[useStaffHolidayRequests] subscribe", {
    //   mode,
    //   currentUserEmail,
    // });

    const onData = (items) => {
      // console.log("[useStaffHolidayRequests] onData", {
      //   mode,
      //   count: items.length,
      //   sample: items.slice(0, 3).map((item) => ({
      //     id: item.id,
      //     staffEmail: item.staffEmail,
      //     ownerStaffEmail: item.ownerStaffEmail,
      //     status: item.status,
      //     createdAt: item.createdAt || null,
      //   })),
      // });
      // console.log("[useStaffHolidayRequests] onData.fullItems", {
      //   mode,
      //   items,
      // });

      if (items.length > 0) {
        // console.table(
        //   items.map((item) => ({
        //     id: item.id,
        //     staffEmail: item.staffEmail || "",
        //     ownerStaffEmail: item.ownerStaffEmail || "",
        //     staffName: item.staffName || item.displayName || "",
        //     status: item.status || "",
        //     leaveType: item.leaveType || "",
        //     startDate: item.startDate || "",
        //     endDate: item.endDate || "",
        //     createdAtSeconds: item.createdAt?.seconds || "",
        //   })),
        // );
      }

      setRequests(items);
      setLoading(false);
    };

    const onError = (err) => {
      // console.error("[useStaffHolidayRequests] onError", {
      //   mode,
      //   currentUserEmail,
      //   err,
      // });
      setError(err);
      setLoading(false);
    };

    if (mode === "admin") {
      return subscribeAdminHolidayRequests({ onData, onError });
    }

    if (mode === "manager") {
      return subscribeManagerHolidayRequests({
        holidayManagerEmail: currentUserEmail,
        onData,
        onError,
      });
    }

    return subscribeMyHolidayRequests({
      staffEmail: currentUserEmail,
      onData,
      onError,
    });
  }, [currentUserEmail, mode]);

  return {
    requests,
    loading,
    error,
  };
};
